


































































































































import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from '@/pages/Pages/BaseItemsPage';
import {EmailGroupEventsItem} from '@/store/email/statistic/types';
import GroupCharts from '@/components/Statistics/GroupCharts.vue';
import { colorClassByDelivered } from '@/utils/page-utils';
import EmailGroupEventsFilter from "@/components/Email/Statistic/EmailGroupEventsFilter.vue";

@Component({
  components: {EmailGroupEventsFilter, ScrollButton, GroupCharts},
  methods: {colorClassByDelivered},
})
export default class EmailGroupEvents extends BaseItemsPage<EmailGroupEventsItem> {

  @Getter('emailStatisticGroupEvents') responseItems!: any;

  is_show_filter = true;
  is_show_graphics = true;

  currentSort = 'date';
  currentSortOrder = 'asc';

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  getFieldName(name: string) {
    if (name == 'total') return 'total'
    if (name == 'partner_price') return 'income'
    if (name == 'provider_price') return 'rate'
    return name
  }

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData(): EmailGroupEventsItem[] {
    return this.responseItems?.events;
  }

  get tableFieldsDefault() {
    return [
      'openings', 'following_links', 'unsubscribings', 'subscribings', 'total'
    ];
  }

  get totalData() {
    let total = {...this.responseItems?.events_summary, totalRow: true}
    if (this.group_by) {
      total.date = this.$t('total');
    } else if (this.optionally_group_by) {
      total[this.optionally_group_by] = this.$t('total');
    }
    return total;
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }
}
